// extracted by mini-css-extract-plugin
export default {"getOutline":"Layout_getOutline__lnnym","Layout":"Layout_Layout__FweHs","InnerArea":"Layout_InnerArea__TP+El"};